import { ListAlt } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableData } from 'components';
import { errorAlert } from 'helpers/alerts';
import { setCurrentMonitor, setMonitor } from 'redux/slices/admin/serviceMonitorSlice';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { getServiceMonitorService } from 'services/admin/serviceMonitorService';
import { List } from '@mui/material';
import Images from 'assets/images';
import Image from 'components/common/Image';

const ServiceMonitorScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { monitor } = useSelector(store => store.serviceMonitor);

  useEffect(() => {
    getServiceMonitorService().then((response) => {
      dispatch(setMonitor(response));
    }).catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerHistorial = (item) => {
    dispatch(setCurrentMonitor(item));
    navigate('../historial');
  }

  return (
    <TableData
      dataRows={monitor}
      // padding='8px'
      dataTitle={[
        "Nombre",
        "Estatus",
        "Fecha y hora del último evento",
        "Tiempo",
        "Fecha y hora de ultima revisión",
      ]}
      formatter={({ name, state, createdAt, lastCheckDate }) => [
        name,
        <><div style={{
          height: 20,
          width: 20,
          borderRadius: 25,
          backgroundColor: state ? '#94F2A4' : '#F29496',
          margin: 'auto'
        }} /></>,
        // message,
        <div>{moment(createdAt).format("DD/MM/YYYY HH:mm:ss")}</div>,
        <div>{moment().from(moment(createdAt), true)} {state ? 'en linea' : 'caído'}</div>,
        lastCheckDate ? moment(lastCheckDate).format("DD/MM/YYYY HH:mm:ss") : '-'
      ]}
      actions={[
        {
          label: "Historial",
          icon: <Image src={Images.icon.actions} alt="actions"  />,
          onClick: (data) => handlerHistorial(data)
        },
      ]}
    />
  )
}

export default ServiceMonitorScreen